var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTumblr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25Z",
    fill: "#001935"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1687 37.5C23.4022 37.5 20.6087 35.5697 20.6087 30.9401V23.5326H17.1875V19.5151C20.954 18.5421 22.5233 15.3092 22.696 12.5H26.6037V18.8716H31.1549V23.5326H26.6037V29.9827C26.6037 31.9131 27.5767 32.5879 29.1304 32.5879H31.3432V37.5H27.1687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblr);
export default __webpack_public_path__ + "static/media/Tumblr.bf116a4551e8533c583713085890f40a.svg";
export { ForwardRef as ReactComponent };